import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavigationBar from "../components/Navigation/NavigationBar";
import Footer from "../components/Footer/Footer";
import "../../App.css";

const RootLayout = () => {
  const [contentLoaded, setContentLoaded] = useState(false);

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    setContentLoaded(false);

    const timer = setTimeout(() => {
      setContentLoaded(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="App">
      <NavigationBar />
      <Outlet context={{ setContentLoaded }} />
      {contentLoaded && <Footer />}
    </div>
  );
};

export default RootLayout;
